import { makeStyles, useTheme } from "@material-ui/core/styles"
import Dialog from "@material-ui/core/Dialog"
import MuiDialogTitle from "@material-ui/core/DialogTitle"
import DialogContent from "@material-ui/core/DialogContent"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"

const SaveSearch = (props) => {
	const { title, open, onClose } = props

	const theme = useTheme()

	const useStyles = makeStyles((theme) => ({
		root: {
			background:"rgba(44, 53, 51, 0.08)",
			padding: theme.spacing(2),
			width: "600px",
			height: "55px",
			"& .MuiTypography-h6": {
				...theme.typography.body2,
				paddingBottom: 1,
			},
		},
		label:{
			fontWeight: 500,
			fontSize: 16,
			paddingLeft: 30,
			color:"#2C3533"
		},
		closeButton: {
			position: "absolute",
			right: theme.spacing(1),
			top: 2,
			color: theme.palette.grey[500],
		},
		dialogContent: {
			padding: theme.spacing(2),
		},
	}))

	const classes = useStyles()

	return (
		<Dialog style={{ ...theme.typography.body2 }} onClose={onClose} aria-labelledby="save-search-dialog-title" open={open} disableEscapeKeyDown={true}>
			<MuiDialogTitle className={classes.root}>
				<span className={classes.label}>{title}</span>
				{onClose ? (
					<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
						<CloseIcon />
					</IconButton>
				) : null}
			</MuiDialogTitle>
			<DialogContent dividers className={classes.dialogContent}>
				{props?.children}
			</DialogContent>
		</Dialog>
	)
}

export default SaveSearch
